var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.416667,
    width: 29.1667,
    height: 29.1667,
    rx: 4.58333,
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.819 8.37084C18.0143 8.56618 18.124 8.83109 18.124 9.1073C18.124 9.38351 18.0143 9.64842 17.819 9.84376L12.6628 15L17.819 20.1563C18.0088 20.3527 18.1138 20.6158 18.1114 20.889C18.109 21.1621 17.9995 21.4234 17.8064 21.6165C17.6132 21.8096 17.352 21.9192 17.0788 21.9215C16.8057 21.9239 16.5426 21.8189 16.3461 21.6292L10.4534 15.7365C10.2581 15.5411 10.1484 15.2762 10.1484 15C10.1484 14.7238 10.2581 14.4589 10.4534 14.2636L16.3461 8.37084C16.5415 8.17556 16.8064 8.06586 17.0826 8.06586C17.3588 8.06586 17.6237 8.17556 17.819 8.37084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.416667,
    width: 29.1667,
    height: 29.1667,
    rx: 4.58333,
    stroke: "#313942",
    strokeWidth: 0.833333
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.84f8d0b09d2f7815ce4cc3da632235ad.svg";
export { ForwardRef as ReactComponent };